import { CellFn } from "@/graphHandling/graphTypes";
import { getRaw } from "@/basedata";
import { backendRoutes } from "@/stores/utils/backendRoutes";
import { getKoulutusmuotoByPredicate } from "@/utils/common";
import { assoc, prop, propEq, split, zipObj } from "ramda";
import { Koulutusmuoto } from "@/types";
import { initializeRajoitteet } from "../helpers/alimaaraykset";

export const fetch_lupaJaMuutospyynto: CellFn = async (
  storeFunctions,
  intl
) => {
  if (!intl) {
    console.warn("Parametri intl puuttuu.");
    return false;
  }

  const urlParams = zipObj(
    [
      "0",
      "locale",
      "rootPage",
      "koulutusmuotoKebabCase",
      "asianhallinta",
      "oid",
      "muutospyyntoUuid",
      "page",
      "language"
    ],
    split("/", window.location.pathname)
  );

  const { oid, koulutusmuotoKebabCase, muutospyyntoUuid } = urlParams;

  const koulutusmuoto = getKoulutusmuotoByPredicate(
    propEq("kebabCase", koulutusmuotoKebabCase),
    intl
  );

  if (koulutusmuoto) {
    const language = "";
    const oppilaitostyyppi = null;
    const oppilaitosId = null;
    let muutospyynto = null;
    if (muutospyyntoUuid && muutospyyntoUuid.length > 4) {
      // Ei käytetä välimuistia, koska tallennuksen jälkeen haku palauttaa vanhan muutospyynnön.
      // Välimuistitus kannattaa toteuttaa backendissä.
      muutospyynto = await getRaw(
        "muutospyynto",
        `${backendRoutes.muutospyynto.path + muutospyyntoUuid}`,
        [],
        0
      );
      storeFunctions.updateGraph(["custom", "muutospyynto"], muutospyynto);
    } else {
      // Uusi asia: Nollataan edellisen muutospyynnön tiedot,
      // jotta uuden asian luomisen yhteydessä ei haeta edellisen muutospyynnön tietoja.
      storeFunctions.updateGraph(["custom", "muutospyynto"], undefined);
    }

    const { koulutustyyppi } = koulutusmuoto as Koulutusmuoto;

    /**
     * Jos muutospyyntö löytyy käytetään aina siltä löytyvää lupaUuid:ta luvan hakemiseksi.
     * Uuden (tallentamattoman) muutospyynnön pohjaksi haetaan viimeisin KJ:n lupa.
     **/
    // Ei käytetä välimuistia, koska tallennuksen jälkeen haku palauttaa vanhan luvan.
    // Välimuistitus kannattaa toteuttaa backendissä.
    let viimeisinLupa = !muutospyynto
      ? await getRaw(
          "viimeisinLupa",
          `${backendRoutes.viimeisinLupa.path}${oid}${
            backendRoutes.viimeisinLupa.postfix
          }?with=all&useKoodistoVersions=false${
            koulutustyyppi ? `&koulutustyyppi=${koulutustyyppi}` : ""
          }${language ? `&kieli=${language}` : ""}${
            oppilaitostyyppi ? "&oppilaitostyyppi=" + oppilaitostyyppi : ""
          }${oppilaitosId ? "&oppilaitosOid=" + oppilaitosId : ""}`,
          [],
          0
        )
      : prop("lupaUuid", muutospyynto)
        ? await getRaw(
            "lupaByUuid",
            `${backendRoutes.lupaByUuid.path}${muutospyynto.lupaUuid}?with=all&useKoodistoVersions=false`,
            [],
            0
          )
        : null;

    if (viimeisinLupa) {
      viimeisinLupa = assoc(
        "rajoitteet",
        initializeRajoitteet(prop("maaraykset", viimeisinLupa)),
        viimeisinLupa
      );
    }
    storeFunctions.updateGraph(["custom", "viimeisinLupa"], viimeisinLupa);
  }

  return true;
};
